window.$ = window.jQuery = require('jquery');
require('@coreui/coreui');
window.swal = require('sweetalert2');
window.multiselect = require('multiselect');
require('select2');
$.fn.select2.defaults.set("language", require('select2/src/js/select2/i18n/pt-BR'));
$.fn.select2.defaults.set("theme", "bootstrap4");

window.bsCustomFileInput = require('bs-custom-file-input');


require('./router');
require('./form');
require('./inputmasks');
require('./cleave-init');
require('./view');
require('./cookies');


swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000
});

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$('#permissions').multiSelect({
    selectableOptgroup: true,
    selectableHeader: "<div class='custom-header'>Disponíveis</div>",
    selectionHeader: "<div class='custom-header'>Vinculadas</div>"
});
$('.flipswitch').each(function () {
    $(this).click(function () {
        $(this).toggleClass("bg-success");
    });
});

$(".item_galery_check").click(function () {
    if ($(this).hasClass("item_galery_select")) {
        $(this).find("input[type=checkbox]").prop('checked', false);
    } else {
        $(this).find("input[type=checkbox]").prop('checked', true);
    }

    $(this).toggleClass("item_galery_select");
});

$(".add_galery").click(function () {
    $(".check:checked").each(function () {

        const name_file = $(this).parent().find("input[name=name_file]").val();
        const path = $(this).parent().find("input[name=path]").val();
        const id_galery = $(this).val();

        const clone = cloneline($(".item-line"));
        const inputs = clone.find('input, select,img,label');
        $.each(inputs, function () {
            const SPMaskBehavior = function (val) {
                    return val.replace(/\D/g, '').length === 11 ? '(99) 99999-9999' : '(99) 9999-99999';
                },
                spOptions = {
                    onKeyPress: function (val, e, field, options) {
                        field.inputmask(SPMaskBehavior.apply({}, arguments), options);
                    }
                };
            const input = $(this);
            //limpa campos de imput
            input.val('');
            //incrementa indice
            if (input.attr('for') != null) {
                var name = increaseIndex($(this).attr('for'));
                console.log(name);
                $(this).attr('for', name);
            } else {
                var name = increaseIndex(input.attr('name'));
                input.attr('name', name);
                const id = increaseIndex(input.attr('id'));
                input.attr('id', id);
                input.attr("value", "");
            }

            if (input.attr("type") == "file") {
                input.on("change", function () {
                    const fileName = $(this).val().split("\\").pop();
                    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
                });
                $(this).siblings(".custom-file-label").addClass("selected").html(name_file);
            }
            if (input.attr("type") == "hidden" && name.indexOf("galery_id") > 0) {
                input.val(id_galery);
            }
            if (input.attr("src") != null) {
                input.attr("src", null)
            }
        });
        $(".item-body").prepend(clone);
    });
});

function cloneline(list) {
    let more = 0;
    let item = null;
    if ($(this).hasClass("item_index")) {
        $.each(list, function () {
            //debugger;
            const input = $(this).find(".item_index");


            const index = parseInt(input.attr("name").match(/\[(\d+)\](?!.*\[\d+\])/)[1]);

            if (item == null) {
                more = index;
                item = $(this).clone();
            }

            if (index > more) {
                more = index;
                item = $(this).clone();
            }


        });
    } else {
        item = list.first().clone();
    }
    return item;
}

function increaseIndex(name) {
    if (name !== undefined) {
        let index = parseInt(name.match(/\[(\d+)\](?!.*\[\d+\])/)[1]);
        index = index + 1;
        name = name.replace(/\[(\d+)\](?!.*\[\d+\])/, '[' + index + ']');
    }
    return name;
}

$(".select_layout").change(function () {
    $.ajax({
        url: URL("condominio/typelayout/" + $(this).val()),
        type: 'get',
        beforeSend: function () {
        },
        success: function (result) {
            document.querySelectorAll('.complementos').forEach(complemento => {
                complemento.classList.add('d-none')
                complemento.querySelectorAll('input').forEach(input => {
                    input.setAttribute('disabled', 'disabled')
                })
            })
            let complemento = document.querySelector('.complementos.' + result.complemento_view)
            if (complemento) {
                complemento.classList.remove('d-none')
                complemento.querySelectorAll('input').forEach(input => {
                    input.removeAttribute('disabled')
                })
            }
        },
        error: function (err) {
            console.log(err);
        }
    });
});
$(".select_layut").change();

$(".guide-show").click(function (e) {
    const element = $("#" + $(this).attr("guide-element"));

    $(".guide_fullscreen").show();
    const position = element.position();
    $(".guide_element").animate({"left": "+=50px"}, "slow");
    $(".guide_element").css('top', "10%");
    $(".guide_element").css('left', "30%");
    $(".guide_element").css('width', element.css("width"));
    $(".guide_element").css('height', element.css("height"));
    $(".guide_element").append(element.clone());
    $(".guide_content").innerText = "asdadasd";
    $(".guide_content").animate({"left": "+=5%"}, "slow");
    $(".guide_content").show();
    $(".guide_element").show();
    $(".guide_close").show();


    element.hide();
});

$(".guide_close").click(function () {
    alert("asdad");
    $(".guide_content").hide();
    $(".guide_element").hide();
    $(".guide_close").hide();
})


function URL(urlpath) {
    let url = "";
    url += window.location.protocol + "//";
    url += window.location.hostname;
    const porta = window.location.href
        .replace(window.location.protocol + "//", '')
        .replace(window.location.pathname, '')
        .replace(window.location.hostname, '')
        .replace(":", "");

    if (!isNaN(porta)) {
        url += ":" + porta;
    }
    if (urlpath.charAt(0) == '/') {
        return url + urlpath;
    } else {
        return url + "/" + urlpath;
    }
}

//multfilter

$('.auto_submit_button').click(function () {
    if ($(this).find("input").prop('checked')) {
        $(this).find("input").prop('checked', false);
    } else {
        $(this).find("input").prop('checked', true);
    }

    $("form").submit();
});
